import {
    OreButton,
    OreHeading,
    OreStack,
    OreText
} from "@edenredespana/oreneta"
import { navigationRoutes } from "@/Shared/ui/routers"
import { useNavigate } from "react-router-dom"
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useTranslation } from "react-i18next"
import errorImage from '@/Shared/ui/assets/errorImage.png'

export const HelpCenterError = (): JSX.Element => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <div className="page-wrapper" 
        style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            alignContent: 'center',
            minHeight: '100vh' 
            }}>
            <OreStack direction="column" placeContent="center" placeItems="center">
                <img src={errorImage} alt="Error" />
                <OreHeading size="title-sm">{t(HelpCenterTranslations.errorPage.title)}</OreHeading>
                <OreText>{t(HelpCenterTranslations.errorPage.subtitle)}</OreText>
                <OreButton
                    category="primary"
                    onClick={() => window.location.reload()}>
                    {t(HelpCenterTranslations.errorPage.retryButton)}
                </OreButton>
                <OreButton
                    category="tertiary"
                    onClick={() => navigate(navigationRoutes.myTickets)}>
                    {t(HelpCenterTranslations.errorPage.backButton)}
                </OreButton>
            </OreStack>
        </div>
    )
}
